import { BRANCHDATA, CURRENT_USER, LOCATION } from "./ActionType";

export const BranchData = (data) => {
  return {
    type: BRANCHDATA,
    payload: data,
  };
};

export const setUserData = (user) => (dispatch) => {
  dispatch({
    type: CURRENT_USER,
    payload: { user },
  });
};

export const setUserLocation = (location) =>{
  
  return{
    type: LOCATION,
    payload: { location },
  };
};
